import {
  Component,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  HttpClient
} from '@angular/common/http';

import {
  FormsModule
} from '@angular/forms';

import {
  Router
} from '@angular/router';

import Swal from 'sweetalert2';

import {
  CheckoutService,
  CheckoutData
} from '../../../service/checkout.service';

import {
  CupomDescontoService
} from '../../../service/cupom-desconto.service';


@Component({
  selector: 'app-checkout-pagamento',

  standalone: true,

  imports: [
    CommonModule,
    FormsModule
  ],

  templateUrl: './checkout-pagamento.component.html',

  styleUrl: './checkout-pagamento.component.css'
})
export class CheckoutPagamentoComponent
  implements OnInit {


  // =====================================================
  // DADOS DO CHECKOUT
  // =====================================================

  dados: CheckoutData | null = null;


  // =====================================================
  // ENDEREÇO DE COBRANÇA
  // =====================================================

  cep = '';

  endereco = '';

  numero = '';

  complemento = '';

  bairro = '';

  cidade = '';

  estado = '';


  // =====================================================
  // PAGAMENTO
  // =====================================================

  formaPagamento:
    'CARTAO' | 'PIX' | null = null;

  processando = false;


  // =====================================================
  // CUPOM
  // =====================================================

  codigoCupom = '';

  cupomAplicado = false;

  valorOriginal = 0;

  valorDesconto = 0;

  valorFinal = 0;

  aplicandoCupom = false;


  constructor(

    private readonly checkoutService: CheckoutService,

    private readonly cupomService: CupomDescontoService,

    private readonly router: Router,

    private readonly http: HttpClient,

    private readonly cdr: ChangeDetectorRef

  ) {}


  // =====================================================
  // INIT
  // =====================================================

  ngOnInit(): void {

    this.carregarDados();

  }


  // =====================================================
  // CARREGAR DADOS DO CHECKOUT
  // =====================================================

  private carregarDados(): void {

    this.dados = this.checkoutService.obter();


    if (
      !this.dados ||
      !this.dados.quartoId
    ) {

      this.mostrarAlerta(
        'warning',
        'Checkout expirado',
        'Os dados da reserva não foram encontrados.'
      ).then(() => {

        this.router.navigate([
          '/'
        ]);

      });

      return;

    }


    if (
      !this.dados.hospedes ||
      this.dados.hospedes.length === 0
    ) {

      this.mostrarAlerta(
        'warning',
        'Hóspedes não encontrados',
        'Informe os dados dos hóspedes antes de continuar.'
      ).then(() => {

        this.router.navigate([
          '/checkout/hospedes'
        ]);

      });

      return;

    }


    // =================================================
    // RESTAURA ENDEREÇO
    // =================================================

    this.cep =
      this.dados.cep || '';

    this.endereco =
      this.dados.endereco || '';

    this.numero =
      this.dados.numero || '';

    this.complemento =
      this.dados.complemento || '';

    this.bairro =
      this.dados.bairro || '';

    this.cidade =
      this.dados.cidade || '';

    this.estado =
      this.dados.estado || '';


    // =================================================
    // RESTAURA PAGAMENTO
    // =================================================

    this.formaPagamento =
      this.dados.formaPagamento || null;


    // =================================================
    // RESTAURA CUPOM
    // =================================================

    this.codigoCupom =
      this.dados.codigoCupom || '';

    this.valorDesconto =
      Number(this.dados.valorDesconto ?? 0);

    this.valorOriginal =
      Number(
        this.dados.valorOriginal ??
        this.dados.valorTotal ??
        0
      );

    this.valorFinal =
      Number(
        this.dados.valorTotal ??
        this.valorOriginal
      );


    this.cupomAplicado =
      !!(
        this.dados.codigoCupom &&
        this.valorDesconto > 0
      );


    /*
     * Quando não existe cupom, o valor original e o valor final
     * devem representar o subtotal da hospedagem + hóspedes + pacotes.
     */
    if (!this.cupomAplicado) {

      this.valorOriginal =
        this.subtotal;

      this.valorFinal =
        this.subtotal;

    }


    this.cdr.detectChanges();

  }


  // =====================================================
  // APLICAR CUPOM
  // =====================================================

  aplicarCupom(): void {

    if (this.aplicandoCupom) {

      return;

    }


    if (!this.dados) {

      this.mostrarAlerta(
        'warning',
        'Checkout expirado',
        'Os dados da reserva não foram encontrados.'
      );

      return;

    }


    const codigo =
      this.codigoCupom.trim();


    if (!codigo) {

      this.mostrarAlerta(
        'warning',
        'Cupom obrigatório',
        'Digite o código do cupom.'
      );

      return;

    }


    /*
     * IMPORTANTE:
     *
     * O valorTotal recebido nesta etapa já deve conter:
     *
     * hospedagem + adultos + crianças + animais + pacotes
     *
     * Portanto, não somamos novamente os hóspedes aqui.
     */
    const valorReserva =
      this.subtotal;


    if (valorReserva <= 0) {

      this.mostrarAlerta(
        'warning',
        'Valor inválido',
        'O valor da reserva precisa ser maior que zero.'
      );

      return;

    }


    this.aplicandoCupom = true;


    this.cupomService
      .aplicar({

        codigo,

        quartoId:
        this.dados.quartoId!,

        valorReserva

      })
      .subscribe({

        next: (resposta) => {

          this.aplicandoCupom = false;


          if (!resposta.valido) {

            this.mostrarAlerta(
              'warning',
              'Cupom inválido',
              resposta.mensagem ||
              'O cupom não pode ser utilizado.'
            );

            this.cdr.detectChanges();

            return;

          }


          // ===========================================
          // ATUALIZA VALORES DO CUPOM
          // ===========================================

          this.codigoCupom =
            resposta.codigo;

          this.valorOriginal =
            Number(resposta.valorOriginal ?? valorReserva);

          this.valorDesconto =
            Number(resposta.valorDescontoCalculado ?? 0);

          this.valorFinal =
            Number(resposta.valorFinal ?? valorReserva);

          this.cupomAplicado = true;


          /*
           * Preserva os dados dos pacotes.
           *
           * O update do checkout é parcial, mas mantemos
           * explicitamente os valores relacionados aos pacotes
           * para evitar perda de dados.
           */
          this.checkoutService.atualizar({

            codigoCupom:
            this.codigoCupom,

            valorOriginal:
            this.valorOriginal,

            valorDesconto:
            this.valorDesconto,

            valorTotal:
            this.valorFinal,

            valorPacotes:
            this.valorPacotes,

            pacotesSelecionados:
              this.dados?.pacotesSelecionados || []

          });


          this.dados =
            this.checkoutService.obter();


          this.cdr.detectChanges();


          this.mostrarAlerta(
            'success',
            'Cupom aplicado!',
            `Você economizou R$ ${this.formatarMoeda(this.valorDesconto)}.`
          );

        },

        error: (erro) => {

          this.aplicandoCupom = false;


          const mensagem =
            this.obterMensagemErro(
              erro,
              'Não foi possível validar o cupom.'
            );


          this.mostrarAlerta(
            'warning',
            'Cupom inválido',
            mensagem
          );


          this.cdr.detectChanges();

        }

      });

  }


  // =====================================================
  // REMOVER CUPOM
  // =====================================================

  removerCupom(): void {

    if (!this.dados) {

      return;

    }


    /*
     * Ao remover o cupom, voltamos para o subtotal original:
     *
     * hospedagem + hóspedes + pacotes
     */
    const subtotal =
      this.subtotalSemCupom;


    this.codigoCupom = '';

    this.cupomAplicado = false;

    this.valorOriginal = subtotal;

    this.valorDesconto = 0;

    this.valorFinal = subtotal;


    this.checkoutService.atualizar({

      codigoCupom: null,

      valorOriginal:
      subtotal,

      valorDesconto: 0,

      valorTotal:
      subtotal,

      valorPacotes:
      this.valorPacotes,

      pacotesSelecionados:
        this.dados.pacotesSelecionados || []

    });


    this.dados =
      this.checkoutService.obter();


    this.cdr.detectChanges();

  }


  // =====================================================
  // SELECIONAR FORMA DE PAGAMENTO
  // =====================================================

  selecionarPagamento(
    forma: 'CARTAO' | 'PIX'
  ): void {

    this.formaPagamento = forma;

  }


  // =====================================================
  // CONTINUAR
  // =====================================================

  continuar(): void {

    if (this.processando) {

      return;

    }


    if (!this.dados) {

      this.mostrarAlerta(
        'warning',
        'Checkout expirado',
        'Os dados da reserva não foram encontrados.'
      );

      return;

    }


    if (!this.validarEndereco()) {

      return;

    }


    if (!this.formaPagamento) {

      this.mostrarAlerta(
        'warning',
        'Forma de pagamento',
        'Selecione uma forma de pagamento.'
      );

      return;

    }


    if (
      !this.dados.hospedes ||
      this.dados.hospedes.length === 0
    ) {

      this.mostrarAlerta(
        'warning',
        'Hóspedes não encontrados',
        'Informe os dados dos hóspedes antes de continuar.'
      );

      return;

    }


    /*
     * Antes de salvar, garante que o valor enviado seja o correto.
     *
     * Com cupom:
     * valorTotal = valor final após desconto.
     *
     * Sem cupom:
     * valorTotal = subtotal com pacotes.
     */
    const valorTotalAtual =
      this.cupomAplicado
        ? this.valorFinal
        : this.subtotalSemCupom;


    this.checkoutService.atualizar({

      cep:
        this.cep.trim(),

      endereco:
        this.endereco.trim(),

      numero:
        this.numero.trim(),

      complemento:
        this.complemento.trim(),

      bairro:
        this.bairro.trim(),

      cidade:
        this.cidade.trim(),

      estado:
        this.estado.trim(),

      formaPagamento:
      this.formaPagamento,

      codigoCupom:
        this.cupomAplicado
          ? this.codigoCupom
          : null,

      valorOriginal:
        this.cupomAplicado
          ? this.valorOriginal
          : this.subtotalSemCupom,

      valorDesconto:
        this.cupomAplicado
          ? this.valorDesconto
          : 0,

      valorTotal:
      valorTotalAtual,

      valorPacotes:
      this.valorPacotes,

      pacotesSelecionados:
        this.dados.pacotesSelecionados || []

    });


    this.dados =
      this.checkoutService.obter();


    if (this.dados.reservaId) {

      this.irParaPagamento();

      return;

    }


    this.criarReserva();

  }


  // =====================================================
  // VALIDAR ENDEREÇO
  // =====================================================

  private validarEndereco(): boolean {

    if (!this.cep.trim()) {

      this.mostrarAlerta(
        'warning',
        'CEP obrigatório',
        'Informe o CEP do endereço de cobrança.'
      );

      return false;

    }


    if (
      this.cep.replace(/\D/g, '').length !== 8
    ) {

      this.mostrarAlerta(
        'warning',
        'CEP inválido',
        'Informe um CEP válido com 8 números.'
      );

      return false;

    }


    if (!this.endereco.trim()) {

      this.mostrarAlerta(
        'warning',
        'Endereço obrigatório',
        'Informe o endereço de cobrança.'
      );

      return false;

    }


    if (!this.numero.trim()) {

      this.mostrarAlerta(
        'warning',
        'Número obrigatório',
        'Informe o número do endereço.'
      );

      return false;

    }


    if (!this.bairro.trim()) {

      this.mostrarAlerta(
        'warning',
        'Bairro obrigatório',
        'Informe o bairro.'
      );

      return false;

    }


    if (!this.cidade.trim()) {

      this.mostrarAlerta(
        'warning',
        'Cidade obrigatória',
        'Informe a cidade.'
      );

      return false;

    }


    if (!this.estado.trim()) {

      this.mostrarAlerta(
        'warning',
        'Estado obrigatório',
        'Informe o estado.'
      );

      return false;

    }


    return true;

  }


  // =====================================================
  // BUSCAR CEP
  // =====================================================

  buscarCep(): void {

    const cepLimpo =
      this.cep.replace(/\D/g, '');


    if (cepLimpo.length !== 8) {

      return;

    }


    this.http
      .get<any>(
        `https://viacep.com.br/ws/${cepLimpo}/json/`
      )
      .subscribe({

        next: (dadosCep) => {

          if (dadosCep.erro) {

            this.mostrarAlerta(
              'warning',
              'CEP não encontrado',
              'Verifique o CEP informado.'
            );

            return;

          }


          this.endereco =
            dadosCep.logradouro || '';

          this.bairro =
            dadosCep.bairro || '';

          this.cidade =
            dadosCep.localidade || '';

          this.estado =
            dadosCep.uf || '';


          this.cdr.detectChanges();

        },

        error: () => {

          this.mostrarAlerta(
            'error',
            'Erro ao consultar CEP',
            'Não foi possível consultar o CEP. Tente novamente.'
          );

          this.cdr.detectChanges();

        }

      });

  }


  // =====================================================
  // CRIAR RESERVA
  // =====================================================

  private criarReserva(): void {

    this.processando = true;


    Swal.fire({

      title: 'Criando reserva...',

      text:
        'Aguarde enquanto preparamos sua reserva.',

      allowOutsideClick: false,

      allowEscapeKey: false,

      didOpen: () => {

        Swal.showLoading();

      }

    });


    this.checkoutService
      .criarReserva()
      .subscribe({

        next: (reserva) => {

          this.checkoutService.salvarReserva(
            reserva
          );


          this.dados =
            this.checkoutService.obter();


          Swal.close();


          this.irParaPagamento();

        },

        error: (erro) => {

          this.processando = false;

          Swal.close();


          const mensagem =
            this.obterMensagemErro(
              erro,
              'Não foi possível criar a reserva.'
            );


          Swal.fire({

            icon: 'error',

            title: 'Erro ao criar reserva',

            text: mensagem,

            confirmButtonText: 'OK',

            confirmButtonColor: '#596238'

          });

        }

      });

  }


  // =====================================================
  // REDIRECIONAR PARA PAGAMENTO
  // =====================================================

  private irParaPagamento(): void {

    if (!this.dados?.reservaId) {

      this.processando = false;


      this.mostrarAlerta(
        'warning',
        'Reserva não encontrada',
        'Não foi possível obter o ID da reserva.'
      );

      return;

    }


    this.processando = false;


    if (this.formaPagamento === 'PIX') {

      this.router.navigate([
        '/checkout/pix'
      ]);

      return;

    }


    if (this.formaPagamento === 'CARTAO') {

      this.router.navigate([
        '/checkout/cartao'
      ]);

      return;

    }


    this.mostrarAlerta(
      'warning',
      'Forma de pagamento',
      'Selecione uma forma de pagamento.'
    );

  }


  // =====================================================
  // VOLTAR
  // =====================================================

  voltar(): void {

    this.router.navigate([
      '/checkout/pacotes'
    ]);

  }


  // =====================================================
  // VALORES
  // =====================================================

  /**
   * Valor dos pacotes selecionados.
   */
  get valorPacotes(): number {

    return Number(
      this.dados?.valorPacotes ?? 0
    );

  }


  /**
   * Valor da hospedagem recebido da etapa anterior.
   *
   * Nesse ponto, o valorTotal da etapa de hóspedes
   * já deve conter hospedagem + adultos + crianças + animais.
   */
  get valorHospedagem(): number {

    const valorTotal =
      Number(this.dados?.valorTotal ?? 0);

    const valorPacotes =
      Number(this.dados?.valorPacotes ?? 0);

    /*
     * Quando existe cupom, valorTotal é o valor final
     * com desconto. Por isso, neste cenário não usamos
     * essa conta para exibir o subtotal.
     */
    if (this.cupomAplicado) {

      return Math.max(
        0,
        this.valorOriginal - this.valorPacotes
      );

    }


    return Math.max(
      0,
      valorTotal - valorPacotes
    );

  }


  /**
   * Subtotal sem desconto.
   */
  get subtotalSemCupom(): number {

    /*
     * Quando o cupom está aplicado, valorOriginal é
     * o subtotal retornado pela API do cupom.
     */
    if (this.cupomAplicado) {

      return Number(
        this.valorOriginal
      );

    }


    return Number(
      this.dados?.valorTotal ?? 0
    );

  }


  /**
   * Subtotal atual usado para aplicar o cupom.
   */
  get subtotal(): number {

    return this.subtotalSemCupom;

  }


  /**
   * Valor total exibido na tela.
   */
  get valorTotal(): number {

    if (this.cupomAplicado) {

      return Number(
        this.valorFinal
      );

    }


    return this.subtotalSemCupom;

  }


  // =====================================================
  // DADOS EXIBIDOS NO RESUMO
  // =====================================================

  get quantidadeNoites(): number {

    return Number(
      this.dados?.quantidadeNoites ?? 0
    );

  }


  get adultos(): number {

    return Number(
      this.dados?.adultos ?? 0
    );

  }


  get criancas(): number {

    return Number(
      this.dados?.criancas ?? 0
    );

  }


  get animais(): number {

    return Number(
      this.dados?.animais ?? 0
    );

  }


  get quantidadeHospedes(): number {

    return Number(
      this.dados?.quantidadeHospedes ?? 0
    );

  }


  get checkIn(): string {

    return this.dados?.checkIn ?? '';

  }


  get checkOut(): string {

    return this.dados?.checkOut ?? '';

  }


  // =====================================================
  // DESCRIÇÃO DINÂMICA DA ACOMODAÇÃO
  // =====================================================

  get descricaoAcomodacao(): string {

    if (
      this.dados?.quartoId === 1
    ) {

      return 'Cabana confortável em meio à natureza';

    }


    if (
      this.dados?.quartoId === 2
    ) {

      return 'Um pedaço da Grécia em meio ao Cerrado de Goiás';

    }


    return 'Acomodação no Paraíso do Cerrado';

  }


  // =====================================================
  // FORMATAÇÕES
  // =====================================================

  formatarData(
    data: string | undefined
  ): string {

    if (!data) {

      return '';

    }


    const partes =
      data.split('-');


    if (
      partes.length !== 3
    ) {

      return data;

    }


    return (
      `${partes[2]}/` +
      `${partes[1]}/` +
      `${partes[0]}`
    );

  }


  private formatarMoeda(
    valor: number
  ): string {

    return Number(valor || 0)
      .toFixed(2)
      .replace('.', ',');

  }


  // =====================================================
  // TRATAMENTO DE ERRO
  // =====================================================

  private obterMensagemErro(
    erro: any,
    mensagemPadrao: string
  ): string {

    if (
      typeof erro?.error === 'string'
    ) {

      return erro.error;

    }


    if (
      typeof erro?.error?.message === 'string'
    ) {

      return erro.error.message;

    }


    if (
      typeof erro?.message === 'string'
    ) {

      return erro.message;

    }


    return mensagemPadrao;

  }


  // =====================================================
  // ALERTAS
  // =====================================================

  private mostrarAlerta(

    icon:
      'success' |
      'error' |
      'warning' |
      'info' |
      'question',

    title: string,

    text: string

  ): Promise<any> {

    return Swal.fire({

      icon,

      title,

      text,

      confirmButtonText: 'OK',

      confirmButtonColor: '#596238',

      customClass: {

        popup: 'swal-cabana'

      }

    });

  }

}
